import { useApi } from './use-api';
import { invoiceService } from '../services/invoice.service';

export function useInvoice(invoiceId: string | undefined) {
  const { loading, result: invoice, error } = useApi(invoiceService.get, invoiceId);
  return { loading, invoice, error };
}
